import { render, staticRenderFns } from "./CrmShop.vue?vue&type=template&id=5504f461&"
import script from "./CrmShop.vue?vue&type=script&lang=js&"
export * from "./CrmShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports